/**
 * The drawer's width, as in the Figma. Mantine converts it to rem, and never lets the drawer grow past the viewport
 * less its offsets, so on narrow screens this is a maximum.
 */
export const ACTION_DRAWER_SIZE = 600;

/** The gap between the floating drawer and the edges of the screen, from the theme's spacing. */
export const ACTION_DRAWER_OFFSET = "var(--mantine-spacing-lg)";
